(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("NekoUI", [], factory);
	else if(typeof exports === 'object')
		exports["NekoUI"] = factory();
	else
		root["NekoUI"] = factory();
})(self, () => {
return 